import { POI } from 'taxi-lib';

export default class Taxi {
    constructor(data) {
        this.acc = data.acc ?? [];
        this.address = data.address ?? null;
        this.call_number = data.call_number;
        this.client = data.client;
        this.connected = data.connected;
        this.lat = data.lat;
        this.lng = data.lng;

        this.taxi_poi = new POI();
        this.taxi_poi.lat = this.lat;
        this.taxi_poi.lng = this.lng;
    }
}